import { useCallback, useEffect, useRef } from "react";
import { AestraPrimaryCareTable } from "../../../data-model/aestraPrimaryCareTable";
import { useAbortableFetch } from "../../../hooks/useAbortableFetch";
import { makePostCallForPrimaryCare } from "../apis/makePostCallForPrimaryCare";
import { PrimaryCareFilterPayload } from "./useFilterPayload";
import { PrimaryCareTableState } from "./usePrimaryCareTableData";

export const useFilterAndSearchEffect = (
  filterPayload: PrimaryCareFilterPayload | null,
  initialDataFetchingExecuted: boolean,
  setTableData: React.Dispatch<React.SetStateAction<AestraPrimaryCareTable[]>>,
  setPrimaryCareState: React.Dispatch<
    React.SetStateAction<PrimaryCareTableState>
  >,
  setPaginationResetCount: React.Dispatch<React.SetStateAction<number>>,
): void => {
  const { runFetch: runFilterAndSearchFetch } = useAbortableFetch(
    makePostCallForPrimaryCare,
  );

  const initialDataFetchingExecutedRef = useRef(initialDataFetchingExecuted);
  const setTableDataRef = useRef(setTableData);
  const setPrimaryCareStateRef = useRef(setPrimaryCareState);
  const setPaginationResetCountRef = useRef(setPaginationResetCount);

  useEffect(() => {
    initialDataFetchingExecutedRef.current = initialDataFetchingExecuted;
    setTableDataRef.current = setTableData;
    setPrimaryCareStateRef.current = setPrimaryCareState;
    setPaginationResetCountRef.current = setPaginationResetCount;
  }, [
    initialDataFetchingExecuted,
    setTableData,
    setPrimaryCareState,
    setPaginationResetCount,
  ]);

  const fetchData = useCallback(() => {
    if (filterPayload) {
      runFilterAndSearchFetch(
        filterPayload,
        setPrimaryCareStateRef.current,
        setTableDataRef.current,
        setPaginationResetCountRef.current,
      );
    }
  }, [filterPayload, runFilterAndSearchFetch]);

  useEffect(() => {
    if (filterPayload && initialDataFetchingExecutedRef.current) {
      fetchData();
    }
  }, [filterPayload, fetchData]);
};
